import { Box, styled } from '@mui/material';

// Footer del sidebar (tour · toggle de tema · logout) separado por hairline.
// La línea de corte baja y el pie se aprieta: así la lista de ítems (Inicio, Agenda, Noticias…)
// gana altura y el tutorial queda pegado al toggle de tema en vez de flotando a media distancia.
const StyledSidebarFooter = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.hairline.main}`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.25),
  marginTop: theme.spacing(0.75),
  paddingTop: theme.spacing(0.75)
}));

export default StyledSidebarFooter;
